/**
 * @file Dismissible element keys.
 *
 * To be used in conjuction with the <DismissiblePersistent> component, these
 * are the keys that are stored in the browser's localStorage.
 */

export const WG_COUNSELOR_LOGIN_PROMPT = 'WG_COUNSELOR_LOGIN_PROMPT';
export const WG_UPSELL_MODAL = 'WG_UPSELL_MODAL';
export const WG_COLLAGE_UPSELL_MODAL = 'WG_COLLAGE_UPSELL_MODAL';
export const ALBUM_CREATE_CUSTOM_TAGS_MSG = 'ALBUM_CREATE_CUSTOM_TAGS_MSG';
export const CONTRIBUTORS_ADD_TO_HOME_SCREEN =
  'CONTRIBUTORS_ADD_TO_HOME_SCREEN';
export const WG_WALDOGRAM_IMAGE_TIP = 'WG_WALDOGRAM_IMAGE_TIP';
export const CUSTOM_PRINT_IMAGE_TIP = 'CUSTOM_PRINT_IMAGE_TIP';
export const PHOTO_OBFUSCATION_OVERLAY_TIP = 'PHOTO_OBFUSCATION_OVERLAY_TIP';
export const WEDDING_BANNER_KEY = 'WEDDING_BANNER_KEY';
export const WG_BOTTOM_BANNER_UPSELL = 'WG_BOTTOM_BANNER_UPSELL';
export const WG_BOTTOM_APP_DOWNLOAD_BANNER = 'WG_BOTTOM_APP_DOWNLOAD_BANNER';
export const EVENT_INVITE_BOTTOM_APP_DOWNLOAD_BANNER =
  'EVENT_INVITE_BOTTOM_APP_DOWNLOAD_BANNER';
export const CONSUMER_VIEW_APP_DOWNLOAD_BANNER =
  'CONSUMER_VIEW_APP_DOWNLOAD_BANNER';
export const PPI_WARNING_PRINT_PRODUCT_CONFIG =
  'PPI_WARNING_PRINT_PRODUCT_CONFIG';
